import React from 'react';
import PropTypes from 'prop-types';
import { ElementImpressionInteraction } from '@nerdwallet/nw-client-lib/tracking';
import { Button } from '@nerdwallet/currency';

const CallToApply = (props) => {
  const { className, payPerCall, productId, productPosition, sectionPosition } =
    props;
  const callElementImpressionProps = {
    id: String(productId),
    type: 'CLICK',
    elementCategory: 'link',
    sectionCategory: 'call-to-apply',
    elementName: `call-to-apply-${productId}`,
    elementContent: payPerCall,
    elementPosition: productPosition,
    sectionPosition,
    pageNumber: null,
  };

  if (!payPerCall) return null;

  return (
    <div className="call-to-apply">
      <ElementImpressionInteraction {...callElementImpressionProps}>
        <Button
          className={className}
          href={`tel:${payPerCall.replace(/\D/g, '')}`}
        >
          Call to apply
        </Button>
      </ElementImpressionInteraction>
    </div>
  );
};

CallToApply.propTypes = {
  className: PropTypes.string,
  payPerCall: PropTypes.string,
  productId: PropTypes.number.isRequired,
  productPosition: PropTypes.number,
  sectionPosition: PropTypes.number,
};

CallToApply.displayName = 'CallToApply';

export default CallToApply;
